import { SxProps } from '@mui/material';

export const notesContainer: SxProps = {
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflow: 'hidden',
  gap: '20px',
};

export const notesHeader = { display: 'flex', gap: '8px' };

export const notesListContainer = {
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  overflowY: 'auto',
  gap: { xs: '16px', xl: '32px' },
};

export const emptyNotesContainer = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
};

export const inputContainer: SxProps = {
  width: '100%',
  mt: 'auto',
  pt: '2px',
  zIndex: '100',
};

export const textField = {
  width: '100%',
  margin: 'auto',
};

export const submitButton = {
  width: '40px',
  height: '40px',
  minWidth: '0px',
  borderRadius: '50px',
};

export const cancelEditButton = { display: 'flex', justifyContent: 'flex-end' };
